import { render, staticRenderFns } from "./WidgetViewSettingsModal.vue?vue&type=template&id=5130c143&scoped=true&"
import script from "./WidgetViewSettingsModal.vue?vue&type=script&lang=js&"
export * from "./WidgetViewSettingsModal.vue?vue&type=script&lang=js&"
import style0 from "./WidgetViewSettingsModal.vue?vue&type=style&index=0&id=5130c143&prod&lang=scss&"
import style1 from "./WidgetViewSettingsModal.vue?vue&type=style&index=1&id=5130c143&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5130c143",
  null
  
)

export default component.exports